module.exports = __webpack_public_path__ + "static/media/34DSS9.491e59d0.jpg";